var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.325,
    height: 16.207,
    viewBox: "0 0 19.325 16.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "telegram",
    transform: "translate(-238.337 -1001.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-telegram-plane",
    "data-name": "Icon awesome-telegram-plane",
    d: "M19.271,6,16.355,19.756c-.22.971-.794,1.212-1.609.755L10.3,17.237,8.158,19.3a1.116,1.116,0,0,1-.893.436l.319-4.525L15.82,7.768c.358-.319-.078-.5-.556-.177L5.082,14,.7,12.63c-.953-.3-.971-.953.2-1.411l17.144-6.6c.794-.3,1.488.177,1.229,1.389Z",
    transform: "translate(238.336 997.369)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.210a43d11bd84d5e089737e99ac526b1.svg";
export { ForwardRef as ReactComponent };